import type { ComponentPropsWithoutRef } from 'react'

import { cn } from '../../../_lib/utils'

const Header = ({ children, className }: ComponentPropsWithoutRef<'header'>) => {
  return <header className={cn('flex w-full justify-between', className)}>{children}</header>
}

const HeaderLeft = ({ children, className }: ComponentPropsWithoutRef<'div'>) => {
  return <div className={cn('flex flex-col gap-2', className)}>{children}</div>
}

const HeaderRight = ({ children, className }: ComponentPropsWithoutRef<'div'>) => {
  return <div className={cn('self-end', className)}>{children}</div>
}

export { Header, HeaderLeft, HeaderRight }
